<template>
  <div v-if="visible" class="interventions">
    <ncs-empty-result v-if="result.pagination.rows === 0"/>
    <template v-else>
      <ncs-page-selector/>
      <ncs-fixed-column-table>
        <table class="table table-striped table-borderless table-sm">
          <tbody>
          <tr v-for="(row, index) in result.interventions" class="interventions-row">
            <td class="interventions-header">
              <a @click.prevent="showContext(row, index)"
                 href="#"
                 class="context-link"
                 v-html="fn(offset + index + 1)"></a>
              <ncs-kwic-result-header :document="row.document" :text="row.text" :elements="row.elements" :matches="[]"/>
            </td>
            <td>
              <span v-for="element in row.elements" :class="elementClass(element)"
                    :title="elementTitle(element)"
                    v-html="elementContent(element)"></span>
            </td>
          </tr>
          </tbody>
        </table>
      </ncs-fixed-column-table>
      <ncs-page-selector/>
    </template>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useApiStore, useNcsI18n, useFormatElements } from 'ncs'

const apiStore = useApiStore()
const { fn } = useNcsI18n()
const { elementContent, elementTitle, elementClass } = useFormatElements()

const offset = computed<number>(() => apiStore.query?.pagination.offset || 0)
const result = computed(() => apiStore.response)
const visible = computed(() => apiStore.query?.type === 'interventions')

const showContext = (row: any, index: number) => {
  const query = {
    type: 'intervention',
    elements: { type: 'units' },
    document: row.document.id,
    uncached: { text: row.text.id, example: index + 1 }
  }
  apiStore.execute(query)
  window.document.dispatchEvent(new CustomEvent('ncs-search', {
    detail: { resultType: 'interventions', action: 'search' }
  }))
}
</script>
